import { useCallback, useState } from 'react';
import {
    ZHLExperienceDestructiveOperationAction,
    ZHLExperienceSupportedDestructiveOperation,
} from 'src/services/graphql/generated/graphql';
import {
    DestructiveOperationActionHandlerConfiguration,
    DestructiveOperationHandler,
} from './DestructiveOperationActionHandlerContext';

export const useDestructiveOperationActionHandlerProviderState = () => {
    const [activeMutation, setActiveMutation] = useState<ZHLExperienceDestructiveOperationAction | null>(null);
    const [configuration, setConfiguration] = useState<DestructiveOperationActionHandlerConfiguration>({});

    const onCancel = useCallback(() => {
        setActiveMutation(null);
        configuration.onCancel?.();
    }, [configuration]);

    const onConfirm = useCallback(() => {
        configuration.onConfirm?.();
        // asserting it exists because we wouldn't be able to be here otherwise
        switch (activeMutation!.operationToPerform) {
            case ZHLExperienceSupportedDestructiveOperation.CANCEL_CALL: {
                // eslint-disable-next-line no-console
                console.log('TODO Handle action', activeMutation);
                configuration.afterMutation?.();
                setActiveMutation(null);
                setConfiguration({});
            }
        }
    }, [activeMutation, configuration]);

    const handleDestructiveOperation = useCallback<DestructiveOperationHandler>((action, config = {}) => {
        setActiveMutation(action);
        setConfiguration(config);
    }, []);

    return {
        // returned for testing purposes only
        _configuration: configuration,
        // returned for testing purposes only
        _activeMutation: activeMutation,
        onCancel,
        onConfirm,
        handleDestructiveOperation,
    };
};
